import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/500.css';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './lib/ErrorBoundary';
import { installErrorReporter, report } from './lib/errorReporter';
import { markAppStarted } from './lib/splash';

markAppStarted();
installErrorReporter();
// One line per launch so a device we can't attach a debugger to still proves the bundle ran.
report('info', `boot ${window.innerWidth}x${window.innerHeight} standalone=${String((navigator as Navigator & { standalone?: boolean }).standalone === true)}`);

// Offline cold start. Service workers need a secure context, so over plain-http LAN dev this
// is skipped and the app still works online.
if (import.meta.env.PROD && 'serviceWorker' in navigator && window.isSecureContext) {
  navigator.serviceWorker.register('/sw.js').catch((e: Error) => report('warning', `sw register failed: ${e.message}`));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
